import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';

// Styles
import styles from './styles.js';

class Image extends Component {
    static propTypes = {
        src: PropTypes.string.isRequired,
        username: PropTypes.string.isRequired
    }

    render() {
        const { src, username } = this.props;
        return (
            <img
                alt={username}
                className={css(styles.image)}
                height="100%"
                src={src}
                title={username}
                width="100%"
            />
        );
    }
}

export default Image;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/AvatarSection/Avatar/Image/Image.jsx